import { render, staticRenderFns } from "./ui-tooltip-icon.vue?vue&type=template&id=eee8dc3e&"
import script from "./ui-tooltip-icon.vue?vue&type=script&lang=ts&"
export * from "./ui-tooltip-icon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports